import { readGuide } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="阅读指南"
            title="四步找到对味的岳母题材作品"
            desc="面对大量同题作品，最有效的方式是先缩小范围。按下面的顺序做一轮筛选，通常几步之内就能把候选清单压缩到可以开读的规模。"
          />
          <div className="mt-8 w-full h-56 md:h-72 rounded-lg overflow-hidden border border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=calm%20warm%20still%20life%20illustration%20of%20a%20cozy%20reading%20desk%20with%20stacked%20manga%20volumes%2C%20cup%20of%20tea%20and%20soft%20desk%20lamp%2C%20muted%20rose%20and%20amber%20tones%2C%20watercolor%20texture%2C%20tasteful%20inviting%20atmosphere%2C%20high%20detail&width=900&height=700&seq=gm-guide-01&orientation=landscape"
              alt="暖调阅读角落静物插画，堆叠的漫画册与茶杯，营造安静阅读氛围"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <ol className="lg:col-span-7 flex flex-col gap-4 md:gap-5">
          {readGuide.map((item) => (
            <li
              key={item.step}
              className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6 flex gap-4 md:gap-6"
            >
              <span className="shrink-0 font-heading text-2xl md:text-3xl font-bold text-primary-500 w-12">
                {item.step}
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}